import Udesk from 'Udesk';
import React from 'react';
import CheckPointConditionComponent from './component';
import { Select, Menu, Dropdown, InputNumber, Button } from 'udesk-ui';
import OperatorListGather from 'Component/pages/components/check-point-operator-list-gather';
import UdeskLocales from 'UdeskLocales';
import { ApplyTimeType } from './components/ApplyTimeType';
import ProblemDetectionMode from './components/ProblemDetectionMode';
import Info from './components/Info';
import Roles from './components/Roles';
import './style.scss';

const { Option } = Select;

export default class CheckPointConditionTemplate extends CheckPointConditionComponent {
    render() {
        let { props, actions, privates } = this;
        let { conditionItem, computes } = privates;
        const { roleDisabled } = computes;
        const { disabled = false } = props;

        return (
            <div className="check-point-condition-item">
                <div
                    className="check-point-condition-item-color"
                    style={{
                        backgroundColor:
                            conditionItem.conditionType === 1
                                ? 'rgba(0,145,255,0.2)'
                                : conditionItem.conditionType === 2
                                ? 'rgba(68,215,182,0.2)'
                                : conditionItem.conditionType === 3
                                ? 'rgba(247,181,0,0.2)'
                                : conditionItem.conditionType === 4
                                ? 'rgba(109,212,0,0.2)'
                                : conditionItem.conditionType === 5
                                ? 'rgba(224, 123, 212, 0.2)'
                                : conditionItem.conditionType === 6
                                ? 'rgba(76, 4, 165, 0.2)'
                                : '',
                    }}
                ></div>
                <div className="check-point-condition-item-content">
                    <div className="check-point-condition-item-content-top">
                        <div className="check-point-condition-item-content-rule-code">
                            {conditionItem.idCode}
                        </div>

                        <div className="check-point-condition-item-content-rule-info">
                            <Info
                                type={
                                    conditionItem.operatorList?.[0].type
                                        ? conditionItem.operatorList?.[0].type
                                        : actions.getOperatorTypes()[0]
                                        ? actions.getOperatorTypes()[0].id
                                        : ''
                                }
                            />
                        </div>

                        <div className="check-point-condition-item-content-rule-type">
                            <Select
                                value={conditionItem.conditionType}
                                style={{ minWidth: 84 }}
                                onChange={actions.ruleTypeChange.params(conditionItem)}
                                disabled={disabled}
                            >
                                {props.conditionTypeList.map((item) => {
                                    return (
                                        <Option key={item.key} value={item.key}>
                                            {item.name}
                                        </Option>
                                    );
                                })}
                            </Select>
                        </div>

                        <OperatorListGather
                            funcType={props.funcType}
                            conditionItem={conditionItem}
                            operatorTypes={actions.getOperatorTypes()}
                            onChange={actions.getGearOptionList}
                            entityFields={this.props.fieldDataList}
                            type={props.type}
                            isAutoAssociateDateSource={props.isAutoAssociateDateSource}
                            isNewAssociate={
                                typeof this.privates.conditionItem?.operatorList?.[0]?.param
                                    ?.version === 'undefined'
                                    ? props.isNewAssociate || 0
                                    : this.privates.conditionItem?.operatorList?.[0]?.param?.version
                            }
                            taskId={props.taskId}
                            hasSummaryRule={props.hasSummaryRule}
                            lang={props.lang}
                            disabled={disabled}
                            isPreprocess={props.isPreprocess}
                        ></OperatorListGather>
                    </div>

                    <div className="check-point-condition-item-content-bottom">
                        <If
                            condition={
                                ![
                                    Udesk.enums.operatorTypes.associate.id,
                                    Udesk.enums.operatorTypes.businessSummary.id,
                                    Udesk.enums.operatorTypes.smartModel.id,
                                    Udesk.enums.operatorTypes.semanticMatching.id,
                                    Udesk.enums.operatorTypes.ticketField.id,
                                    Udesk.enums.operatorTypes.audio.id,
                                    Udesk.enums.operatorTypes.videoSound.id,
                                    Udesk.enums.operatorTypes.videoFootage.id,
                                    Udesk.enums.operatorTypes.videoFile.id,
                                    Udesk.enums.operatorTypes.voiceMessage.id,
                                    Udesk.enums.operatorTypes.picture.id,
                                    Udesk.enums.operatorTypes.document.id,
                                    Udesk.enums.operatorTypes.customerField.id,
                                    Udesk.enums.operatorTypes.fakeCaseClosure.id,
                                ].includes(conditionItem.operatorType)
                            }
                        >
                            {/* 检测角色 */}
                            <div style={{ marginLeft: 43, display: 'inline-block' }}>
                                {
                                    UdeskLocales.current.pages.tasks.manage.template.checkPoint
                                        .configuration.role
                                }
                                <Roles
                                    value={conditionItem.applyRole}
                                    onChange={actions.selectMenuItem.params('applyRole')}
                                    isSales={props.isSales}
                                    disabled={roleDisabled || disabled}
                                />
                            </div>

                            {/* 前置算子 */}
                            <div
                                style={{ marginRight: 16, marginLeft: 48, display: 'inline-block' }}
                            >
                                {
                                    UdeskLocales.current.pages.tasks.manage.template.checkPoint
                                        .configuration.preposition
                                }
                                <Dropdown
                                    overlay={
                                        <Menu
                                            onClick={actions.selectMenuItem.params(
                                                'applyConditionIdCode'
                                            )}
                                        >
                                            <Menu.Item key="">
                                                {UdeskLocales.current.fix.null}
                                            </Menu.Item>
                                            {props.conditionList &&
                                                props.conditionList.length > 1 &&
                                                props.conditionList
                                                    .filter(
                                                        (item) =>
                                                            item.idCode !== conditionItem.idCode &&
                                                            item.conditionType !== 4
                                                    )
                                                    .map((item) => {
                                                        return (
                                                            <Menu.Item key={item.idCode}>
                                                                {item.idCode}
                                                            </Menu.Item>
                                                        );
                                                    })}
                                        </Menu>
                                    }
                                    trigger={['click']}
                                    disabled={disabled}
                                >
                                    <a
                                        className="udesk-ui-dropdown-link"
                                        style={{
                                            color: disabled ? 'rgba(0, 0, 0, 0.15)' : '#1B6DFF',
                                        }}
                                        onClick={(e) => e.preventDefault()}
                                    >
                                        {conditionItem.applyConditionIdCode
                                            ? conditionItem.applyConditionIdCode
                                            : UdeskLocales.current.fix.null}
                                        <span className="udesk-qa-react-web-iconfont">
                                            &#xe686;
                                        </span>
                                    </a>
                                </Dropdown>
                            </div>

                            <If condition={actions.getShowResponseStart()}>
                                <div style={{ marginLeft: 43, display: 'inline-block' }}>
                                    {
                                        /* 应答起始句 */ UdeskLocales['current'].components
                                            .checkPointConditionListGather.checkPointCondition
                                            .template.responseOpeningSentence
                                    }
                                    <Dropdown
                                        overlay={
                                            <Menu
                                                onClick={actions.selectMenuItem.params(
                                                    'responseStart'
                                                )}
                                            >
                                                {Udesk.enums.responseStart.map((item) => {
                                                    return (
                                                        <Menu.Item key={item.id}>
                                                            {item.name}
                                                        </Menu.Item>
                                                    );
                                                })}
                                            </Menu>
                                        }
                                        trigger={['click']}
                                        disabled={disabled}
                                    >
                                        <a
                                            className="udesk-ui-dropdown-link"
                                            style={{
                                                color: disabled ? 'rgba(0, 0, 0, 0.15)' : '#1B6DFF',
                                            }}
                                            onClick={(e) => e.preventDefault()}
                                        >
                                            {Udesk.enums.responseStart.getName(
                                                conditionItem.responseStart
                                            )}
                                            <span className="udesk-qa-react-web-iconfont">
                                                &#xe686;
                                            </span>
                                        </a>
                                    </Dropdown>
                                </div>
                            </If>

                            <If condition={conditionItem.applyConditionIdCode}>
                                <div
                                    style={{ marginRight: 8, display: 'inline-block', width: 100 }}
                                >
                                    <Dropdown
                                        overlay={
                                            <Menu
                                                onClick={actions.selectMenuItem.params(
                                                    'applyConditionHitType'
                                                )}
                                            >
                                                {Udesk.enums.preOperatorHitTypes.map((item) => {
                                                    return (
                                                        <Menu.Item key={item.id}>
                                                            {item.name}
                                                        </Menu.Item>
                                                    );
                                                })}
                                            </Menu>
                                        }
                                        trigger={['click']}
                                        disabled={disabled}
                                    >
                                        <a
                                            className="udesk-ui-dropdown-link"
                                            style={{
                                                color: disabled ? 'rgba(0, 0, 0, 0.15)' : '#1B6DFF',
                                            }}
                                            onClick={(e) => e.preventDefault()}
                                        >
                                            {Udesk.enums.preOperatorHitTypes.getName(
                                                conditionItem.applyConditionHitType
                                            )}
                                            <span className="udesk-qa-react-web-iconfont">
                                                &#xe686;
                                            </span>
                                        </a>
                                    </Dropdown>
                                </div>
                            </If>

                            {/* 检测范围 */}
                            <div style={{ marginRight: 16, display: 'inline-block' }}>
                                {
                                    UdeskLocales.current.pages.tasks.manage.template.checkPoint
                                        .configuration.range
                                }
                                <Dropdown
                                    overlay={
                                        <Menu
                                            onClick={actions.selectMenuItem.params(
                                                'applyOperatorScope'
                                            )}
                                        >
                                            {Udesk.enums.applyOperatorScopes
                                                .filter((item) => {
                                                    if (
                                                        !conditionItem.applyConditionIdCode ||
                                                        conditionItem.applyConditionHitType ===
                                                            Udesk.enums.preOperatorHitTypes.none.id
                                                    ) {
                                                        return item.id !== 2;
                                                    } else {
                                                        return true;
                                                    }
                                                })
                                                .filter((e) => {
                                                    if (
                                                        (props.type || []).includes(
                                                            Udesk.enums.inspectDataSources.voiceCall
                                                                .id
                                                        )
                                                    ) {
                                                        return true;
                                                    } else {
                                                        return e.id !== 4;
                                                    }
                                                })
                                                .map((item) => {
                                                    return (
                                                        <Menu.Item key={item.id}>
                                                            {item.name}
                                                        </Menu.Item>
                                                    );
                                                })}
                                        </Menu>
                                    }
                                    trigger={['click']}
                                    disabled={disabled}
                                >
                                    <a
                                        className="udesk-ui-dropdown-link"
                                        style={{
                                            color: disabled ? 'rgba(0, 0, 0, 0.15)' : '#1B6DFF',
                                        }}
                                        onClick={(e) => e.preventDefault()}
                                    >
                                        {conditionItem.operatorList?.[0].applyOperatorScope &&
                                            Udesk.enums.applyOperatorScopes.getName(
                                                conditionItem.operatorList?.[0].applyOperatorScope
                                                    .id
                                            )}
                                        <span className="udesk-qa-react-web-iconfont">
                                            &#xe686;
                                        </span>
                                    </a>
                                </Dropdown>
                            </div>
                            <If
                                condition={
                                    conditionItem.operatorList?.[0].applyOperatorScope &&
                                    conditionItem.operatorList?.[0].applyOperatorScope.id ===
                                        Udesk.enums.applyOperatorScopes.preCondition.id
                                }
                            >
                                <Select
                                    style={{ width: 100, marginRight: 8 }}
                                    value={conditionItem.applyConditionScope}
                                    onChange={actions.selectMenuItem.params('applyConditionScope')}
                                    className="check-range-apply-condition-scope"
                                    disabled={disabled}
                                >
                                    <For
                                        each="item"
                                        index="index"
                                        of={Udesk.enums.applyConditionScopes}
                                    >
                                        <Select.Option value={item.id}>{item.name}</Select.Option>
                                    </For>
                                </Select>
                                <If
                                    condition={[
                                        Udesk.enums.applyConditionScopes.before.id,
                                        Udesk.enums.applyConditionScopes.after.id,
                                        Udesk.enums.applyConditionScopes.around.id,
                                    ].includes(conditionItem.applyConditionScope)}
                                >
                                    <InputNumber
                                        // type="number"
                                        min={0}
                                        className="check-range-apply-condition-limit"
                                        value={conditionItem.applyConditionLimit}
                                        onChange={actions.changeInputValue.params(
                                            conditionItem,
                                            'applyConditionLimit'
                                        )}
                                        onBlur={actions.validateRangeValue.params(
                                            conditionItem,
                                            'applyConditionLimit',
                                            conditionItem.applyConditionLimit
                                        )}
                                        disabled={disabled}
                                    />
                                    {UdeskLocales.current.components.checkRange.numberTipTwo}
                                </If>
                            </If>
                            <If
                                condition={
                                    conditionItem.operatorList?.[0].applyOperatorScope.id ===
                                    Udesk.enums.applyOperatorScopes.scope.id
                                }
                            >
                                {
                                    UdeskLocales.current.pages.tasks.manage.template.checkPoint
                                        .configuration.from
                                }
                                <InputNumber
                                    value={conditionItem.applyScopeStart}
                                    onChange={actions.changeInputValue.params(
                                        conditionItem,
                                        'applyScopeStart'
                                    )}
                                    placeholder={
                                        UdeskLocales.current.components.operatorListGather
                                            .pleaseEnter
                                    }
                                    onBlur={actions.validateGrabInterval.params(
                                        conditionItem,
                                        'applyScopeStart'
                                    )}
                                    style={{ width: 150 }}
                                    disabled={disabled}
                                />
                                {
                                    UdeskLocales.current.pages.tasks.manage.template.checkPoint
                                        .configuration.to
                                }
                                <InputNumber
                                    value={conditionItem.applyScopeEnd}
                                    onChange={actions.changeInputValue.params(
                                        conditionItem,
                                        'applyScopeEnd'
                                    )}
                                    placeholder={
                                        UdeskLocales.current.components.operatorListGather
                                            .pleaseEnter
                                    }
                                    onBlur={actions.validateGrabInterval.params(
                                        conditionItem,
                                        'applyScopeEnd'
                                    )}
                                    style={{ width: 150 }}
                                    disabled={disabled}
                                />
                                {
                                    UdeskLocales.current.pages.tasks.manage.template.checkPoint
                                        .configuration.end
                                }
                                {/* ，忽略小于 */}
                                {
                                    UdeskLocales['current'].components.checkPointConditionListGather
                                        .checkPointCondition.template.IgnoreLess
                                }
                                <InputNumber
                                    value={conditionItem.preIgnoreWordCount}
                                    onChange={actions.changeInputValue.params(
                                        conditionItem,
                                        'preIgnoreWordCount'
                                    )}
                                    placeholder={
                                        UdeskLocales.current.components.operatorListGather
                                            .pleaseEnter
                                    }
                                    style={{ width: 150 }}
                                    disabled={disabled}
                                    min={0}
                                    precision={0}
                                />
                                {/* 字的句子 */}
                                {
                                    UdeskLocales['current'].components.checkPointConditionListGather
                                        .checkPointCondition.template.theSentenceOfTheWord
                                }
                            </If>

                            <If
                                condition={
                                    conditionItem.operatorList?.[0].applyOperatorScope.id ===
                                    Udesk.enums.applyOperatorScopes.scopeTime.id
                                }
                            >
                                {
                                    UdeskLocales.current.pages.tasks.manage.template.checkPoint
                                        .configuration.from
                                }
                                <InputNumber
                                    value={conditionItem.applyScopeStartSecond}
                                    onChange={actions.changeInputValue.params(
                                        conditionItem,
                                        'applyScopeStartSecond'
                                    )}
                                    placeholder={
                                        UdeskLocales.current.components.operatorListGather
                                            .pleaseEnter
                                    }
                                    style={{ width: 150 }}
                                    disabled={disabled}
                                />
                                {/* 秒至第 */}
                                {
                                    UdeskLocales['current'].components.checkPointConditionListGather
                                        .checkPointCondition.template.secondsToNo
                                }
                                <InputNumber
                                    value={conditionItem.applyScopeEndSecond}
                                    onChange={actions.changeInputValue.params(
                                        conditionItem,
                                        'applyScopeEndSecond'
                                    )}
                                    placeholder={
                                        UdeskLocales.current.components.operatorListGather
                                            .pleaseEnter
                                    }
                                    style={{ width: 150 }}
                                    disabled={disabled}
                                />
                                {/* 秒 */}
                                {
                                    UdeskLocales['current'].components.checkPointConditionListGather
                                        .checkPointCondition.template.seconds
                                }
                            </If>

                            {/* 检测时间 */}
                            <If condition={actions.getShowApplyTimeType()}>
                                <ApplyTimeType
                                    conditionItem={conditionItem}
                                    selectMenuItem={actions.selectMenuItem.params('applyTimeType')}
                                    applyTimeIdChange={actions.selectMenuItem.params('applyTimeId')}
                                    disabled={disabled}
                                />
                            </If>
                            {/* 问题检测方式 */}
                            <If condition={actions.getShowProblemDetectionMode()}>
                                <ProblemDetectionMode
                                    value={{
                                        detectMode: conditionItem.simpleSentenceFlag,
                                        crossingQuantity: conditionItem.crossingQuantity,
                                        ignoreWordCount: conditionItem.ignoreWordCount,
                                        sentenceLength: conditionItem.sentenceLength,
                                    }}
                                    onChange={actions.selectMenuItem.params('simpleSentenceFlag')}
                                />
                            </If>
                        </If>

                        <If
                            condition={[Udesk.enums.operatorTypes.associate.id].includes(
                                conditionItem.operatorType
                            )}
                        >
                            <Button
                                type="link"
                                size="small"
                                onClick={actions.onAssociateVersionChange}
                                disabled={disabled}
                            >
                                {
                                    UdeskLocales.current.pages.tasks.manage.template.checkPoint
                                        .configuration[
                                        (
                                            typeof conditionItem?.operatorList?.[0]?.param
                                                ?.version === 'undefined'
                                                ? props.isNewAssociate || 0
                                                : conditionItem?.operatorList?.[0]?.param?.version
                                        )
                                            ? 'changeToOld'
                                            : 'changeToNew'
                                    ]
                                }
                            </Button>
                        </If>
                    </div>
                </div>
            </div>
        );
    }
}
